export default function appendEventFunctions(functions) {
    const func = e => {
        functions.forEach(f => {
            if (f) f(e);
        });
    };
    return func;
}
